import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledToastContainer = styled.div`
  display: flex;
  padding: 1.6rem;
  border-radius: ${({ theme }) => theme.radius.big};
  justify-content: center;
  gap: 1rem;
  align-self: stretch;
`;

export const StyledInfoToastContainer = styled(StyledToastContainer)`
  border: 0.1rem solid ${({ theme }) => theme.colors.info.main};
  background: ${({ theme }) => theme.colors.info.lighter};
`;

export const StyledWarningToastContainer = styled(StyledToastContainer)`
  margin-top: 2rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.warning.main};
  background: ${({ theme }) => theme.colors.warning.lighter};
`;

export const StyledErrorToastContainer = styled(StyledToastContainer)`
  border: 0.1rem solid ${({ theme }) => theme.colors.error.main};
  background: ${({ theme }) => theme.colors.error.lighter};
`;

export const StyledToastContent = styled.p`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: normal;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledWarningIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.warning.main};
  border: none;
`;

export const StyledInfoIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.info.main};
  border: none;
`;

export const StyledErrorIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.error.main};
  border: none;
`;
